import { jwtDecode, type JwtPayload } from 'jwt-decode'

export function isAccessTokenExpired(accessToken: string): boolean {
  const { exp } = jwtDecode<JwtPayload>(accessToken)
  return exp == null || Date.now() >= exp * 1000
}
